import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "800",
  height: "800",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
}

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M10 0v2.6a5.002 5.002 0 0 1 3.995 4.674L14 7.5v3.768A2 2 0 0 1 13 15a2 2 0 0 1-1.134-3.647l.134-.085V7.5a3 3 0 0 0-1.828-2.762L10 4.67V7L6 3.5 10 0ZM3 1a2 2 0 0 1 1.134 3.647L4 4.732v6.536A2 2 0 0 1 3 15a2 2 0 0 1-1.134-3.647L2 11.268V4.732A2 2 0 0 1 3 1Z"
    }, null, -1)
  ]))]))
}
export default { render };